import { Input, Space, Typography } from 'antd';
import FormItem from 'components/FormItem';
import FormLayout from 'components/FormLayout';
import React from 'react';

function Unit({ disabled }) {
  return (
    <FormLayout.Section>
      <Space direction="vertical" className="mb-1">
        <Typography.Text className="font-bold">Unit</Typography.Text>
        <Typography.Text className="text-[#A7A9A9]">
          Selling or packaging unit for this item (e.g. Box, Tray, Platter, People, Each). If unset, defaults to Item. This is not the ingredient unit of measure.
        </Typography.Text>
      </Space>
      <FormItem name="catering_label" fullWidth>
        <Input placeholder="e.g. Box" disabled={disabled} />
      </FormItem>
    </FormLayout.Section>
  );
}

export default Unit;
